module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-wedding-ceremony-d99a0a407bc770632f9b410d9536b8f0.png";